export enum PaymentTypes {
  CreditCard = 'CreditCard',
  WireTransfer = 'WireTransfer',
  Check = 'Check',
  ACH = 'ACH',
}
